// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "d75af5a917d96b4d8aa41ecc91267f599bb7a880/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};